import { FC, useState } from 'react'
import { MainLayout } from 'views/layouts'
import { StrokedButton } from 'views/components/UI/Buttons'
import InterpretationDetail from '../interpretation-detail'
import { BetesaTitle, WrapperTitle, ButtonWrapper } from '../styled'

const ReinterpretationDetail: FC = () => {
  const [isEditing, setIsEditing] = useState<boolean>(false)

  return (
    <MainLayout>
      <WrapperTitle>
        <BetesaTitle>Reinterpretación de betesa</BetesaTitle>
        <ButtonWrapper>
          <StrokedButton style={{ marginTop: '20px' }} onClick={() => setIsEditing(!isEditing)}>
            {isEditing ? 'Cancelar reinterpretación' : 'Reinterpretar'}
          </StrokedButton>
        </ButtonWrapper>
      </WrapperTitle>
      <InterpretationDetail disable={!isEditing} isReinterpretation={true} />
    </MainLayout>
  )
}

export default ReinterpretationDetail
